import { gql } from '@/__generated__/index.ts';

export const CreateOAuthCodeMutation = gql(`
    mutation CreateOAuthCodeMutation($input: CreateOAuthCodeInput!) {
      createOAuthCode(input: $input) {
        code
      }
    }
  `);
